import { Box } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import Carousel from '@/common/components/Carousel/Carousel'
import PackageCarouselCard from '@/common/components/PackageCarouselCard'
import { theme } from '@/theme/theme'
import { PhishingSimulationPackage } from '@/types/phishingSimulations'
import { VideosPackageResponse } from '@/types/videos'

type PackagesCaruselViewProps = {
  packages: PhishingSimulationPackage[] | VideosPackageResponse[]
  showPreview: (asset: PhishingSimulationPackage | VideosPackageResponse) => void
  savedSimulationPackages?: string[]
  saveSimulationPackageToggle: (id: string) => void
}

const PackagesCaruselView: FC<PackagesCaruselViewProps> = ({
  packages,
  showPreview,
  savedSimulationPackages = [],
  saveSimulationPackageToggle,
}) => {
  const { t } = useTranslation()
  return (
    <Box marginTop={theme.spacing(5)}>
      <Carousel
        title={
          (packages[0] as VideosPackageResponse)?.videos ? t('videoLibrary.packages') : t('simulationLibrary.packages')
        }>
        {packages.map((packageObject: PhishingSimulationPackage | VideosPackageResponse) => (
          <Box padding={theme.spacing(0, 1)} minWidth={theme.spacing(45)} key={packageObject.id}>
            <PackageCarouselCard
              showPreview={showPreview}
              packageObject={packageObject}
              isSaved={savedSimulationPackages.includes(packageObject.id)}
              saveSimulationPackageToggle={saveSimulationPackageToggle}
            />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}

export default PackagesCaruselView
